import script from "./RowBestellung.vue?vue&type=script&setup=true&lang=js"
export * from "./RowBestellung.vue?vue&type=script&setup=true&lang=js"

import "./RowBestellung.vue?vue&type=style&index=0&id=25dd64a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25dd64a4"]])

export default __exports__